import "./styles.scss";
import * as React from "react";
import { StyleProps, useTheme } from "@vebox/etui-system";
import { Theme } from "@vebox/etui-themes";
import { Display } from "../../../../../components/Display";
import { Badge } from "@vebox/etui-core";
import { CensusCoolerContext } from "../../providers/CensusCollerProvider";

export enum CENSUS_COOLER_STATUS_TEXTS {
	ERROR = "Error",
	FAILED = "Failed",
	COMPLETED = "Completed",
	NONE = "None",
	IN_PROGRESS = "In Progress",
}

interface StatusChipProps {
	status: CENSUS_COOLER_STATUS_TEXTS;
	customLabel?: string;
	badgeStyle?: StyleProps;
	boxStyle?: React.CSSProperties;
}

interface Status {
	label: string | CENSUS_COOLER_STATUS_TEXTS;
	color: string;
}

export const getStatusColor = (
	status: CENSUS_COOLER_STATUS_TEXTS,
	theme: Theme,
): string => {
	switch (status) {
		case CENSUS_COOLER_STATUS_TEXTS.ERROR:
		case CENSUS_COOLER_STATUS_TEXTS.FAILED:
			return theme.palette.red[100];
		case CENSUS_COOLER_STATUS_TEXTS.COMPLETED:
			return theme.palette.green[100];
		case CENSUS_COOLER_STATUS_TEXTS.IN_PROGRESS:
			return theme.palette.turquoise[100];
		default:
			return theme.palette.grey[20];
	}
};

const getStatus = (
	status: CENSUS_COOLER_STATUS_TEXTS,
	theme: Theme,
	getStatusText: (status: CENSUS_COOLER_STATUS_TEXTS) => string,
	customLabel?: string,
): Status => {
	switch (status) {
		case CENSUS_COOLER_STATUS_TEXTS.FAILED:
		case CENSUS_COOLER_STATUS_TEXTS.COMPLETED:
		case CENSUS_COOLER_STATUS_TEXTS.IN_PROGRESS:
			return {
				label: customLabel ?? getStatusText(status),
				color: getStatusColor(status, theme),
			};
		default:
			return undefined;
	}
};
export const StatusChip: React.FC<StatusChipProps> = ({
	status,
	customLabel,
	boxStyle,
	badgeStyle,
}) => {
	const theme = useTheme();
	const { getStatusText } = React.useContext(CensusCoolerContext);

	const chipStatus = getStatus(
		status,
		theme as Theme,
		getStatusText,
		customLabel,
	);
	return (
		<Display
			isVisible={chipStatus && status !== CENSUS_COOLER_STATUS_TEXTS.NONE}
		>
			<div className={"status-chip"} style={boxStyle}>
				<Badge
					text={chipStatus?.label}
					size={"sm"}
					animationDisabled={false}
					styles={{
						root: { bg: chipStatus?.color, fontWeight: "bold", ...badgeStyle },
					}}
				/>
			</div>
		</Display>
	);
};
